'use client';
import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

const propTypes = {
    /**
   * Whether or not to hide the child content on xs screens
   * @default false
   */ xs: PropTypes.bool,
    /**
   * Whether or not to hide the child content on sm screens
   * @default false
   */ sm: PropTypes.bool,
    /**
   * Whether or not to hide the child content on md screens
   * @default false
   */ md: PropTypes.bool,
    /**
   * Whether or not to hide the child content on lg screens
   * @default false
   */ lg: PropTypes.bool,
    /**
   * Whether or not to hide the child content on xl screens
   * @default false
   */ xl: PropTypes.bool
};
const Hidden = createComponent({
    displayName: 'Hidden',
    root: 'div',
    propTypes,
    requiredStyleKeys: SWAN_STYLE_KEY_MAP.hidden,
    propConfig: {
        classNames (props) {
            const classNameSet = new Set();
            const { xs = false, sm = false, md = false, lg = false, xl = false } = props;
            if (xs) classNameSet.add('swan-hidden-xs');
            if (sm) classNameSet.add('swan-hidden-sm');
            if (md) classNameSet.add('swan-hidden-md');
            if (lg) classNameSet.add('swan-hidden-lg');
            if (xl) classNameSet.add('swan-hidden-xl');
            return classNameSet;
        }
    }
});

export { Hidden };
